/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
    import * as helper from "../../js/helper";
	import like_component from "../components/like-component.vue";
    const __vue_script__ ={
        components: {
            like_component:like_component,
        },
		name:'mashro_component',
        props: {
            mashro: {
                type: Object,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading: false,
                ad_type_color: '#0000ff',
                ad_type_color_wt: '#0000ff',
                creation_date: new Date(),
                url:"",
			};
		},
        mounted(){
            let domain = (new URL(window.location.href));
            url = domain.hostname;
            this.is_loading = true;
            this.creation_date = new Date(this.mashro.creation);
            this.is_loading = false;
            global.emitter.emit("refresh-tooltips");
        },
		methods: {
            askUnpublishMashro(){
                if(this.loading || !frappe.session_user || frappe.session_user == "Guest")
                    return;
                bootbox.confirm({
                    message: `<div class="alert alert-danger" role="alert">
                        `+helper.t("Do you want to unpublish this project?")+`
                    </div>`,
                    buttons: {
                        confirm: {
                            label: helper.t("Yes"),
                            className: 'btn-success'
                        },
                        cancel: {
                            label: helper.t("No"),
                            className: 'btn-danger'
                        }
                    },
                    backdrop: true,
                    callback: (results) => results?this.unpublishMashro():console.log("cancel"),
                });
            },
            async unpublishMashro (){
                this.form_sent = true;
                let params = {
                    mashro_name : this.mashro.name,
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.unpublish_mashro",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    this.loading = false
                    global.emitter.emit("refresh-tanent");
                    helper.showSuccess("Project unpublished",()=>{
                        location.reload();
                    });
                } catch (e) {
                    this.error = true;
                    this.exceptions = helper.showException(e);
                }
                this.loading = false
            },
            askPublishMashro(){
                if(this.loading || !frappe.session_user || frappe.session_user == "Guest")
                    return;
                bootbox.confirm({
                    message: `<div class="alert alert-danger" role="alert">
                        `+helper.t("Do you want to publish this project?")+`
                    </div>`,
                    buttons: {
                        confirm: {
                            label: helper.t("Yes"),
                            className: 'btn-success'
                        },
                        cancel: {
                            label: helper.t("No"),
                            className: 'btn-danger'
                        }
                    },
                    backdrop: true,
                    callback: (results) => results?this.publishMashro():console.log("cancel"),
                });
            },
            async publishMashro (){
                this.form_sent = true;
                let params = {
                    mashro_name : this.mashro.name,
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.publish_mashro",
                        type: "POST",
                        data: JSON.stringify(params) //for POST request
                    });
                    this.loading = false
                    global.emitter.emit("refresh-tanent");
                    helper.showSuccess("Project published",()=>{
                        location.reload();
                    });
                } catch (e) {
                    this.error = true;
                    this.exceptions = helper.showException(e);
                }
                this.loading = false
            },
		},
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "single-properties-item animate__animated animate__fadeInUp delay-0-2s"
    },
    [
      _c("div", { staticClass: "col-sm-12 properties-img mb-1" }, [
        _c("div", { staticClass: "row py-1" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "actions d-flex justify-content-start px-1" },
              [
                _vm.mashro.owned || _vm.mashro.managed
                  ? [
                      _vm.mashro.published
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.askUnpublishMashro()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-circle-xmark",
                                attrs: {
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-placement": "top",
                                  title: _vm.helper.t("Unpublish")
                                }
                              })
                            ]
                          )
                        : _c(
                            "a",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.askPublishMashro()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-circle-check",
                                attrs: {
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-placement": "top",
                                  title: _vm.helper.t("Publish")
                                }
                              })
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "/account/edit-project/" + _vm.mashro.name,
                            target: "_blank"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa-solid fa-pen-to-square",
                            attrs: {
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: _vm.helper.t("Edit")
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#transfer-mashro-modal",
                            "data-bs-mashro-name": _vm.mashro.name,
                            "data-bs-mashro-title": _vm.mashro.title,
                            "data-bs-member-name": _vm.mashro.manager_user
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa-solid fa-shuffle",
                            attrs: {
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: _vm.helper.t("Transfer")
                            }
                          })
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "me-auto" }),
                _vm._v(" "),
                _vm.mashro.ready_made
                  ? _c("div", { staticClass: "feature" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.helper.t("Ready-made units")) +
                          "\n                        "
                      )
                    ])
                  : _c("div", { staticClass: "feature" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.helper.t("On the map")) +
                          "\n                        "
                      )
                    ])
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("a", {
          staticClass: "image-holder",
          style: {
            "background-image":
              "url(/" + encodeURIComponent(_vm.mashro.image.substr(1)) + ")"
          },
          attrs: { href: "/project/" + _vm.mashro.name }
        }),
        _vm._v(" "),
        _vm.mashro.owned
          ? _c(
              "span",
              {
                staticClass: "actions top",
                class: _vm.frappe.lang_dir == "rtl" ? "left" : "right",
                staticStyle: { "background-color": "#ffffff99" }
              },
              [
                !_vm.mashro.published
                  ? _c("a", [
                      _c("i", {
                        staticClass: "fa-solid fa-circle-xmark",
                        attrs: {
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Unpublished")
                        }
                      })
                    ])
                  : _c("a", [
                      _c("i", {
                        staticClass: "fa-solid fa-circle-check",
                        attrs: {
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Published")
                        }
                      })
                    ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "bottom fw-bold text-black container gap-2",
            class: _vm.frappe.lang_dir == "ltr" ? "left" : "right",
            style: { "background-color": "unset !important" }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "g-0 d-flex flex-wrap justify-content-start gap-1 mb-2 pt-1"
              },
              _vm._l(_vm.mashro.property_types, function(type_index) {
                return _c(
                  "div",
                  {
                    staticClass: "badge bg-light text-dark",
                    staticStyle: { flex: "0 0 calc((100% - 0.5rem) / 3)" }
                  },
                  [
                    _c("small", [
                      _vm._v(_vm._s(_vm.helper.t(type_index.type + "s")))
                    ])
                  ]
                )
              }),
              0
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "properties-content" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("h3", [_vm._v(_vm._s(_vm.helper.t(_vm.mashro.title)))])
        ]),
        _vm._v(" "),
        _vm.mashro.owned && _vm.mashro.manager_full_name
          ? _c(
              "small",
              {
                staticClass: "text-info",
                attrs: {
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top",
                  title: _vm.helper.t("Managed By")
                }
              },
              [
                _c("i", { staticClass: "fa-solid fa-briefcase" }),
                _vm._v(" "),
                _c("span", { staticClass: "ms-0" }, [
                  _vm._v(_vm._s(_vm.mashro.manager_full_name))
                ]),
                _vm._v(" "),
                _c("br")
              ]
            )
          : !_vm.mashro.owned
          ? _c("small", { staticClass: "text-info" }, [
              _c("span", { staticClass: "ms-0" }, [
                _vm._v(_vm._s(_vm.mashro.company_name))
              ]),
              _vm._v(" "),
              _c("br")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("small", [
          _c("i", { staticClass: "ri-map-pin-line" }),
          _vm._v(" " + _vm._s(_vm.mashro.address) + "\n            ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "section-card mashro-info d-flex justify-content-between px-3 py-1 mb-1"
          },
          [
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.helper.t("Units")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.mashro.units))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.helper.t("Area")))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Starting: {0}", [
                      _vm.helper.t("{0} sq.m.", [_vm.mashro.area_min])
                    ])
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.helper.t("Price")))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.helper.t("Starting: {0}", [
                      _vm.helper.nFormatter(_vm.mashro.price_min)
                    ])
                  )
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "justify-content-start px-0 m-0" }, [
          _vm.mashro.masjid
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Masjid"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-mosque" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mashro.shopping
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Shopping"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-cart-shopping" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mashro.health
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Health"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-heart-pulse" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mashro.park
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Park"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-tree" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mashro.school_male
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Male School"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-school-flag" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mashro.school_female
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Female School"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-school-flag" })]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-end details-btn" }, [
        _c(
          "a",
          {
            staticClass: "btn ms-auto h-25",
            attrs: { href: "/project/" + _vm.mashro.name, target: "_self" }
          },
          [
            _c("small", [_vm._v(_vm._s(_vm.helper.t("Details")))]),
            _vm._v(" "),
            _c("i", {
              class:
                _vm.frappe.lang_dir == "rtl"
                  ? "ri-arrow-left-line"
                  : "ri-arrow-right-line"
            })
          ]
        )
      ])
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a2f9c9e2_0", { source: "\n.icon{\n    width:10%;\n}\n.properties-img .image-holder{\n    display: block;\n    padding-top: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n.badge{\n    background-color: rgba(255, 255, 255, 0.9) !important;\n    border-color: grey;\n    font-size: 1rem;\n    font-weight: normal;\n    height: 2.5rem;\n    padding-top: 12px;\n}\n.single-properties-item .properties-img > span{\n    padding: 5px;\n}\n.details-btn *{\n    color: #014116;\n}\n.mashro-info *{\n    font-size: 0.85rem;\n}\n.feature{\n    color: #014116;\n    font-size: 1rem;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/components/mashro-component.vue"],"names":[],"mappings":";AAiPA;IACA,SAAA;AACA;AACA;IACA,cAAA;IACA,iBAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;AACA;AACA;IACA,qDAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;IACA,cAAA;IACA,iBAAA;AACA;AACA;IACA,YAAA;AACA;AACA;IACA,cAAA;AACA;AACA;IACA,kBAAA;AACA;AACA;IACA,cAAA;IACA,eAAA;AACA","file":"mashro-component.vue","sourcesContent":["<template>\r\n\t<div class=\"single-properties-item animate__animated animate__fadeInUp delay-0-2s\">\r\n        <div class=\"col-sm-12 properties-img mb-1\">\r\n            <div class=\"row py-1\">\r\n                <div class=\"col-12\">\r\n                    <div class=\"actions d-flex justify-content-start px-1\">\r\n                        <template v-if=\"mashro.owned || mashro.managed\" @click.prevent=\"\">\r\n                            <a v-if=\"mashro.published\" href=\"#\" @click.prevent=\"askUnpublishMashro()\">\r\n                                <i class=\"fa-solid fa-circle-xmark\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Unpublish')\"></i>\r\n                            </a>\r\n                            <a v-else role=\"button\" @click.prevent=\"askPublishMashro()\">\r\n                                <i class=\"fa-solid fa-circle-check\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Publish')\"></i>\r\n                            </a>\r\n                            <a :href=\"'/account/edit-project/'+mashro.name\" target=\"_blank\">\r\n                                    <i class=\"fa-solid fa-pen-to-square\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Edit')\"></i>\r\n                                </a>\r\n                            <a href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#transfer-mashro-modal\" :data-bs-mashro-name='mashro.name' :data-bs-mashro-title='mashro.title' :data-bs-member-name='mashro.manager_user'>\r\n                                <i class=\"fa-solid fa-shuffle\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Transfer')\"></i>\r\n                            </a>\r\n                        </template>\r\n                        <span class=\"me-auto\"></span>\r\n                        <div v-if=\"mashro.ready_made\" class=\"feature\">\r\n                            {{ helper.t(\"Ready-made units\") }}\r\n                        </div>\r\n                        <div v-else class=\"feature\">\r\n                            {{ helper.t(\"On the map\") }}\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <a class=\"image-holder\"\r\n                :href=\"'/project/'+mashro.name\"\r\n                :style=\"{ 'background-image': `url(/${encodeURIComponent(mashro.image.substr(1))})`, }\">\r\n            </a>\r\n            \r\n            <span v-if=\"mashro.owned\" class=\"actions top\" :class=\"frappe.lang_dir=='rtl'?'left':'right'\" style=\"background-color: #ffffff99;\">\r\n                <a v-if=\"!mashro.published\">\r\n                    <i class=\"fa-solid fa-circle-xmark\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Unpublished')\"></i>\r\n                </a>\r\n                <a v-else>\r\n                    <i class=\"fa-solid fa-circle-check\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Published')\"></i>\r\n                </a>\r\n            </span>\r\n\r\n            <span class=\"bottom fw-bold text-black container gap-2\" :class=\"frappe.lang_dir=='ltr'?'left':'right'\" :style=\"{'background-color':'unset !important'}\">\r\n                <div class=\"g-0 d-flex flex-wrap justify-content-start gap-1 mb-2 pt-1\">\r\n                    <div v-for=\"type_index in mashro.property_types\" class=\"badge bg-light text-dark\"\r\n                    style=\"flex: 0 0 calc((100% - 0.5rem) / 3);\">\r\n                        <small>{{ helper.t(type_index.type+\"s\") }}</small>\r\n                    </div>\r\n                </div>\r\n            </span>\r\n        </div>\r\n        <div class=\"properties-content\">\r\n            <div class=\"d-flex justify-content-between\">\r\n                <h3>{{ helper.t(mashro.title) }}</h3>\r\n            </div>\r\n            <small v-if=\"mashro.owned && mashro.manager_full_name\" class=\"text-info\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Managed By')\">\r\n                <i class=\"fa-solid fa-briefcase\"></i>\r\n                <span class=\"ms-0\">{{  mashro.manager_full_name  }}</span>\r\n                <br>\r\n            </small>\r\n            <small v-else-if=\"!mashro.owned\" class=\"text-info\">\r\n                <span class=\"ms-0\">{{  mashro.company_name  }}</span>\r\n                <br>\r\n            </small>\r\n            <small>\r\n                <i class=\"ri-map-pin-line\"></i>&nbsp;{{ mashro.address }}\r\n            </small>\r\n            <div class=\"section-card mashro-info d-flex justify-content-between px-3 py-1 mb-1\">\r\n                <div>\r\n                    <b>{{ helper.t(\"Units\") }}</b>\r\n                    <p>{{ mashro.units }}</p>\r\n                </div>\r\n                <div>\r\n                    <b>{{ helper.t(\"Area\") }}</b>\r\n                    <p>{{ helper.t(\"Starting: {0}\",[helper.t(\"{0} sq.m.\",[mashro.area_min])]) }}</p>\r\n                </div>\r\n                <div>\r\n                    <b>{{ helper.t(\"Price\") }}</b>\r\n                    <p>{{ helper.t(\"Starting: {0}\",[helper.nFormatter(mashro.price_min)]) }}</p>\r\n                </div>\r\n            </div>\r\n            <ul class=\"justify-content-start px-0 m-0\">\r\n                <li v-if=\"mashro.masjid\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Masjid')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-mosque\"></i>\r\n                </li>\r\n                <li v-if=\"mashro.shopping\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Shopping')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-cart-shopping\"></i>\r\n                </li>\r\n                <li v-if=\"mashro.health\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Health')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-heart-pulse\"></i>\r\n                </li>\r\n                <li v-if=\"mashro.park\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Park')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-tree\"></i>\r\n                </li>\r\n                <li v-if=\"mashro.school_male\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Male School')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-school-flag\"></i>\r\n                </li>\r\n                <li v-if=\"mashro.school_female\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Female School')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-school-flag\"></i>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"text-end details-btn\">\r\n            <a :href=\"'/project/'+mashro.name\" target=\"_self\" class=\"btn ms-auto h-25\">\r\n                <small>{{ helper.t(\"Details\") }}</small>&nbsp;<i :class=\"frappe.lang_dir=='rtl'?'ri-arrow-left-line':'ri-arrow-right-line'\"></i>\r\n            </a>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n    import * as global from \"../../js/global\" ;\r\n    import * as helper from \"../../js/helper\";\r\n\timport like_component from \"../components/like-component.vue\";\r\n    export default{\r\n        components: {\r\n            like_component:like_component,\r\n        },\r\n\t\tname:'mashro_component',\r\n        props: {\r\n            mashro: {\r\n                type: Object,\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                is_loading: false,\r\n                ad_type_color: '#0000ff',\r\n                ad_type_color_wt: '#0000ff',\r\n                creation_date: new Date(),\r\n                url:\"\",\r\n\t\t\t};\r\n\t\t},\r\n        mounted(){\r\n            let domain = (new URL(window.location.href));\r\n            url = domain.hostname;\r\n            this.is_loading = true;\r\n            this.creation_date = new Date(this.mashro.creation);\r\n            this.is_loading = false;\r\n            global.emitter.emit(\"refresh-tooltips\");\r\n        },\r\n\t\tmethods: {\r\n            askUnpublishMashro(){\r\n                if(this.loading || !frappe.session_user || frappe.session_user == \"Guest\")\r\n                    return;\r\n                bootbox.confirm({\r\n                    message: `<div class=\"alert alert-danger\" role=\"alert\">\r\n                        `+helper.t(\"Do you want to unpublish this project?\")+`\r\n                    </div>`,\r\n                    buttons: {\r\n                        confirm: {\r\n                            label: helper.t(\"Yes\"),\r\n                            className: 'btn-success'\r\n                        },\r\n                        cancel: {\r\n                            label: helper.t(\"No\"),\r\n                            className: 'btn-danger'\r\n                        }\r\n                    },\r\n                    backdrop: true,\r\n                    callback: (results) => results?this.unpublishMashro():console.log(\"cancel\"),\r\n                });\r\n            },\r\n            async unpublishMashro (){\r\n                this.form_sent = true;\r\n                let params = {\r\n                    mashro_name : this.mashro.name,\r\n                };\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.unpublish_mashro\",\r\n                        type: \"POST\",\r\n                        // data: params //for GET request\r\n                        data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    this.loading = false\r\n                    global.emitter.emit(\"refresh-tanent\");\r\n                    helper.showSuccess(\"Project unpublished\",()=>{\r\n                        location.reload();\r\n                    });\r\n                } catch (e) {\r\n                    this.error = true;\r\n                    this.exceptions = helper.showException(e);\r\n                }\r\n                this.loading = false\r\n            },\r\n            askPublishMashro(){\r\n                if(this.loading || !frappe.session_user || frappe.session_user == \"Guest\")\r\n                    return;\r\n                bootbox.confirm({\r\n                    message: `<div class=\"alert alert-danger\" role=\"alert\">\r\n                        `+helper.t(\"Do you want to publish this project?\")+`\r\n                    </div>`,\r\n                    buttons: {\r\n                        confirm: {\r\n                            label: helper.t(\"Yes\"),\r\n                            className: 'btn-success'\r\n                        },\r\n                        cancel: {\r\n                            label: helper.t(\"No\"),\r\n                            className: 'btn-danger'\r\n                        }\r\n                    },\r\n                    backdrop: true,\r\n                    callback: (results) => results?this.publishMashro():console.log(\"cancel\"),\r\n                });\r\n            },\r\n            async publishMashro (){\r\n                this.form_sent = true;\r\n                let params = {\r\n                    mashro_name : this.mashro.name,\r\n                };\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.publish_mashro\",\r\n                        type: \"POST\",\r\n                        data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    this.loading = false\r\n                    global.emitter.emit(\"refresh-tanent\");\r\n                    helper.showSuccess(\"Project published\",()=>{\r\n                        location.reload();\r\n                    });\r\n                } catch (e) {\r\n                    this.error = true;\r\n                    this.exceptions = helper.showException(e);\r\n                }\r\n                this.loading = false\r\n            },\r\n\t\t},\r\n\t}\r\n</script>\r\n\r\n<style>\r\n    .icon{\r\n        width:10%;\r\n    }\r\n    .properties-img .image-holder{\r\n        display: block;\r\n        padding-top: 100%;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n    .badge{\r\n        background-color: rgba(255, 255, 255, 0.9) !important;\r\n        border-color: grey;\r\n        font-size: 1rem;\r\n        font-weight: normal;\r\n        height: 2.5rem;\r\n        padding-top: 12px;\r\n    }\r\n    .single-properties-item .properties-img > span{\r\n        padding: 5px;\r\n    }\r\n    .details-btn *{\r\n        color: #014116;\r\n    }\r\n    .mashro-info *{\r\n        font-size: 0.85rem;\r\n    }\r\n    .feature{\r\n        color: #014116;\r\n        font-size: 1rem;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/mashro-component.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__